import Layout from '../../internal/Layout.vue'
import EquipmentImport from './equipmentImport.vue'

const EquipmentImportRoutes = {
  component: Layout,
  children: [
    {
      name: 'equipmentImport',
      path: '/',
      component: EquipmentImport,
      meta: {
        module: 'importar_equipamentos',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
      },
    },
  ],
}

export default EquipmentImportRoutes
